import { Divider, Grid } from "@mui/material";
import React from "react";
import { Header } from "../../Components/Header/Header";
import { useForm } from "react-hook-form";
import { WSTabs } from "../../Components/Tabs/WSTabs";
import SanctionedLoanList from "./Sanction/SanctionedLoanList";
import CompletedLoanList from "./Complete/CompletedLoanList";
import DisbursedLoanList from "./Disbursed/DisbursedList";
import RejectedLoanList from "./Rejected/RejectedLoanList";

export const ActionReconcilationOrChequeList: React.FC<any> = React.memo(
    (props) => {

        const {
            control,
            formState: { errors }
        } = useForm<any>();

        const tabsData: any[] = [
            { label: "Loan Sanctioned List", content: <SanctionedLoanList /> },
            { label: "Loan Disbursed List", content: <DisbursedLoanList /> },
            { label: "Rejected Loan List", content: <RejectedLoanList /> },
            {
                label: "Loan Completed List",
                content: <CompletedLoanList />
            }
        ];

        return (
            <>
                {" "}
                <Grid item container spacing={2}>
                    <Grid item sm={12} xs={12}>
                        <Divider />
                    </Grid>
                </Grid>
                <Header
                    type="card"
                    isDivider={true}
                    title={`Loan Lifecycle Overview`}
                    id={"ActionReconcilationOrCheque"}
                    headerSx={{ marginTop: 0 }}
                />
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <WSTabs
                            id="adasd"
                            control={control}
                            name="tabs"
                            tabs={tabsData}
                            justifyTabs="flex-start"
                        />
                    </Grid>
                </Grid>
            </>
        );
    }
);
